export default __webpack_public_path__ + "static/media/chatPreviewEmpty.3859f899.svg";